/* eslint-disable */
export const checkForZeroOrNull = (value: number | string): boolean => {
  if (value === 0 || value === null) return true;
  return false;
};

export const checkForZeroOrNullOrUndefined = (value: number | string | undefined): boolean => {
  if (typeof value === 'undefined' || checkForZeroOrNull(value)) return true;
  return false;
};

export const checkForAccurateDataInArray = (valueArray: Array<number | string | undefined>): boolean => {
  for (const value in valueArray) {
    if (checkForZeroOrNullOrUndefined(value)) return true;
  }
  return false;
};

export const compareDates = (date1: Date, date2: Date, allowOverlap: boolean = false): boolean => {
  const date1Instance = new Date(date1);
  const date2Instance = new Date(date2);
  if (allowOverlap) {
    return date1Instance.valueOf() >= date2Instance.valueOf();
  }
  return date1Instance.valueOf() > date2Instance.valueOf();
};

export const getDataWithDebounce = <T extends (...args: any[]) => any>(
  func: T,
  delay: number,
): ((...args: Parameters<T>) => void) => {
  let timeoutId: ReturnType<typeof setTimeout>;
  return (...args: Parameters<T>): void => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func.apply(null, args);
    }, delay);
  };
};
